// form labels often need unique IDs - this can be used to generate some
let uniqueId = 0;

export function createID(): string {
    uniqueId++;
    return "dllpatch_" + uniqueId;
};

// shorthand functions
export function createElementClass<K extends keyof HTMLElementTagNameMap>(elName: K, className?: string, textContent?: string, innerHTML?: string): HTMLElementTagNameMap[K] {
    const el = document.createElement(elName);
    el.className = className || '';
    el.textContent = textContent || ''; // optional
    // overrides textContent with HTML if provided
    if (innerHTML) {
        el.innerHTML = innerHTML;
    }
    return el;
};

export function createInput(type: string, id: string, className?: string): HTMLInputElement {
    const el = document.createElement('input');
    el.type = type;
    el.id = id;
    el.className = className || '';
    return el;
};

export function createLabel(labelText: string, htmlFor: string, className?: string): HTMLLabelElement {
    const el = document.createElement('label');
    el.textContent = labelText;
    el.htmlFor = htmlFor;
    el.className = className || '';
    return el;
};
